export default __webpack_public_path__ + "static/media/laundry2-beforeB-1920w.c7dc5edb.avif";